const DOMAIN_IE = 'expondo.ie';
const DEFAULT_IMAGE_DOMAIN = 'expondo.de';
const DEFAULT_DOMAIN = 'expondo.com';
const POD_NAMESPACE_INDICATOR = 'MY_POD_NAMESPACE';
const PREPROD_NAMESPACE = 'expondo-dev1-europe-west1-gcp-storefrontcloud-io';

export { DOMAIN_IE, DEFAULT_IMAGE_DOMAIN, DEFAULT_DOMAIN, POD_NAMESPACE_INDICATOR, PREPROD_NAMESPACE };
